import React from "react";
import { hero } from "../mock";
import Sparkles from "./Sparkles";

export default function Hero({ onCta }) {
  return (
    <section className="relative overflow-hidden">
      <div className="hero-glow absolute inset-0" aria-hidden="true" />
      <Sparkles />
      <div className="relative z-10 mx-auto max-w-4xl px-6 pt-14 pb-24 text-center">
        {/* Badge */}
        <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 backdrop-blur-sm">
          <span className="h-1.5 w-1.5 rounded-full bg-violet-400" />
          <span className="text-[13px] text-white/70">{hero.badge}</span>
        </div>

        {/* Title */}
        <h1 className="font-display text-[46px] font-bold leading-[1.05] tracking-tight text-white sm:text-[64px] md:text-[76px]">
          {hero.titleLine1}
          <br />
          {hero.titlePlain}
          <span className="text-gradient-violet">{hero.titleAccent}</span>
          <br />
          {hero.titleLine3}
        </h1>

        {/* Subtitle */}
        <p className="mx-auto mt-7 max-w-2xl text-base leading-relaxed text-white/55 sm:text-[17px]">
          {hero.subtitle}
        </p>

        {/* CTA */}
        <div className="mt-9 flex items-center justify-center">
          <button
            onClick={onCta}
            className="btn-lavender rounded-full px-7 py-3.5 text-[15px] font-semibold"
          >
            {hero.cta}
          </button>
        </div>
      </div>
    </section>
  );
}
